export const MAX_CART_ITEMS = 3;
export const SHOTS_PER_PAGE = 24;
export const FAKE_LOAD_TIMEOUT = 450;
